module.exports = {
  Either: require('./src/Either'),
  Future: require('./src/Future'),
  Identity: require('./src/Identity'),
  IO: require('./src/IO'),
  lift2: require('./src/lift2'),
  lift3: require('./src/lift3'),
  Maybe: require('./src/Maybe'),
  Reader: require('./src/Reader'),
  State: require('./src/State'),
  Tuple: require('./src/Tuple')
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda-fantasy/index.js
// module id = 21
// module chunks = 0